import React from 'react';
import Header from '../../component/header/SectionHeader';
import './styles.css';

/**
 * Header for Contact Me.
 *
 * @component
 * @category Contact Me
 */
const ContactUsHeader = () => {
  const ContactUsText = () => (
    <span>
      Do Contact Me if there is any error or improvement or wish to collaborate on this project
    </span>
  );

  return (
    <div className="contact-us-header-box">
      <Header sectionHeader={'Contact Me'} translateX={'translateX(23px)'} />
      <ContactUsText />
    </div>
  );
};

export default ContactUsHeader;
